module.exports = __webpack_public_path__ + "img/安全高效的数据共享@2x.2e2fb863.png";